module.exports = __webpack_public_path__ + "img/ug523.41d82db0.png";